import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewContainerRef, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { SidebarService, SidebarTemplate } from './core/service/sidebar.service';
import { NavigationEnd, Router } from '@angular/router';
import { ForceRefreshService } from './core/service/force-refresh.service';
import { Subscription, filter } from 'rxjs';
import { PhotoPreviewData, PhotoPreviewService } from './core/service/photo-preview-service';

@Component({
    selector: 'app-root',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private readonly _host: ViewContainerRef,
    private readonly _location: Location,
    private readonly _sidebarService: SidebarService,
    private readonly _photoPreviewService: PhotoPreviewService,
    private readonly _router: Router,
    private readonly _versionChangeService: ForceRefreshService
  ) {
    this.year = new Date().getFullYear();

  }

  private forceRefreshSubscription: Subscription;

  get hideFooter(): boolean {
    const routes = [''];
    return (
      (this._host.element.nativeElement.firstChild.offsetWidth < 578 && routes.includes(this._location.path())) || window.innerWidth < 768
    );
  }
  year: number;

  // Sidebar
  isSidebarOpen: boolean = false;
  sidebarContent: SidebarTemplate;
  showDefaultHeader: boolean = true;
  bigSize: boolean = true;

  ngOnInit() {
    // Sidebar subs
    this._sidebarService.sidebarContent$.subscribe(content => {
      this.sidebarContent = content;
      this.showDefaultHeader = content?.showDefaultHeader ?? true;
    });
    this._sidebarService.sidebarOpen$.subscribe(isOpen => {
      this.isSidebarOpen = isOpen;
    });

    // Photo Preview subs
    this._photoPreviewService.photoPreviewContent$.subscribe(content => {
      this.photoPreviewContent = content;
    });
    this._photoPreviewService.photoPreviewOpen$.subscribe(isOpen => {
      this.isPhotoPreviewOpen = isOpen;
    });

    this._versionChangeService.markAppReloaded();
    this.forceRefreshSubscription = this._router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
      this._versionChangeService.reloadIfRequired();
    });

    // Sticky Footer subs
    // this._stickyFooterService.stickyFooterContent$.subscribe(content => {
    //   this.stickyFooterTemplate = content.template;
    // });
  }

  ngOnDestroy() {
    this.forceRefreshSubscription?.unsubscribe();
  }

  handleSidebarClose(isOpen: boolean) {
    this.sidebarContent?.onClose?.();
    this._sidebarService.toggleSidebar(!isOpen);
  }

  // Photo Preview
  isPhotoPreviewOpen: boolean = false;
  photoPreviewContent: PhotoPreviewData;

  handlePhotoPreviewClose(isOpen: boolean) {
    this._photoPreviewService.setPhotoPreviewState(!isOpen);
  }

  // Sticky Footer
  // stickyFooterTemplate: TemplateRef<any> | null = null;
}
